// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
var _ = require('lodash');
import { connect } from 'react-redux';
// import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import GoogleMapReact from 'google-map-react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import LocationIcon from 'grommet/components/icons/base/Location';

import { browserHistory as history } from 'react-router';
import { updateSiteAction, addSiteAction } from '../../actions/actions';
import { navEnable } from '../../actions/nav';

import constants from '../../Constants';
import { updateUserLocation, updateSignUpUserLocation } from '../../actions/settings';

import Button from 'grommet/components/Button';

class ChooseLocationMap extends Component {

  constructor(props) {
    super(props);

    this.mapClick = this.mapClick.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.mapLoaded = this.mapLoaded.bind(this);
    this.addSite = this.addSite.bind(this);
    this.backBtnClick = this.backBtnClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.placesHandleSelect = this.placesHandleSelect.bind(this);
    this.state = {
      center: false,
      showContextMenu: false,
      contextMenTopPos: 0,
      contextMenuLeftPos: 0,
      markersArr: [],
      showModalOverlay: false,
      address: '',
    }
  }
  componentWillMount() {
    this.props.dispatch(navEnable(false));
    this.getCenter()

  }


  componentDidMount() {
    console.log(this.props);
    //  this.props.dispatch(navEnable(false));
  }
  componentDidUpdate() {


  }
  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
  }
  getCenter() {
    if (this.props.userLocation && this.props.userLocation.latitude) {
      this.setState({
        center: {
          lat: this.props.userLocation.latitude ? Number(this.props.userLocation.latitude) : null,
          lng: this.props.userLocation.longitude ? Number(this.props.userLocation.longitude) : null,
        }
      });
    } else if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((position) => {
        let postionObj = {
          lat: position.coords.latitude, lng: position.coords.longitude
        }
          // console.log('postionObj::-', postionObj)
        this.setState({
          center: postionObj
        });
      }, (error) => {
        this.setState({
          center: {
            lat: 37.09024, lng: -95.712891
          },
          zoom: 5
        });
      });
    } else {
      this.setState({
        center: {
          lat: 37.09024, lng: -95.712891
        },
        zoom: 5
      });
    }
  }
  mapClick(e) {
    this.setState({
      showContextMenu: false,
      contextMenTopPos: 0,
      contextMenuLeftPos: 0
    })
  }
  mapLoaded(mapObj) {

    mapObj.map.addListener('rightclick', (event) => {
      // let position = {
      //   latitude: event.latLng.lat(),
      //   longitude: event.latLng.lng()
      // }

      this.setState({
        showContextMenu: true,
        contextMenTopPos: event.pixel.y,
        contextMenuLeftPos: event.pixel.x,
        markerLat: event.latLng.lat(),
        markerLong: event.latLng.lng()
      })
    });
  }
  addSite(obj) {
    let position = {
      latitude: this.state.markerLat,
      longitude: this.state.markerLong
    }
    if(this.props.userProfile && this.props.userProfile.username){
      this.props.dispatch(updateUserLocation(position))
      history.push({
        pathname: constants.ROUTES.SETTINGS,
        // search: '?name=' + sitename_enc,
        state: {}
      })
    }
    else {
      this.props.dispatch(updateSignUpUserLocation(position))
      history.push({
        pathname: constants.ROUTES.SIGNUP,
        state: {}
      })
    }
    this.setState({
      showContextMenu: false,
      showModalOverlay: true
    });
  }

  backBtnClick() {
    if(!this.props.userProfile) {
      history.push({
        pathname: constants.ROUTES.SIGNUP,
        state: {}
      })
    }
    else {
      history.push({
        pathname: constants.ROUTES.SETTINGS,
        state: {}
      })
    }
  }
  onChange(address) {
    this.setState({
      address: address
    })
  }
  placesHandleSelect(address) {
    this.setState({
      address: address
    });
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        // console.log('Success Yay', { lat, lng })
        this.setState({
          center: {
            lat: lat, lng: lng
          },
          zoom: 20
        })
      })
      .catch((error) => {
          // console.log('Error:', error)

      })
  }
  render() {

    let zoom = 11;
    let containerStyle = {
      height: '100%'
    };
    let contextMenuStyle = {
      display: this.state.showContextMenu ? 'block' : 'none',
      top: this.state.contextMenTopPos + 45,
      left: this.state.contextMenuLeftPos
    }

    if (this.state.center) {

      let markersComponents = null;
      if (!_.isEmpty(this.props.userLocation)) {
        markersComponents = <MarkerComponent key={1} lat={this.props.userLocation.latitude}
          lng={this.props.userLocation.longitude} />
      }
      const inputProps = {
        type: "text",
        placeholder: "🔍 Enter address",
        value: this.state.address,
        onChange: this.onChange,
      }
      const AutocompleteItem = ({ suggestion }) => (<div><i className="fa fa-map-marker" />{suggestion}</div>)

      return (
        <div style={containerStyle} className="location-map">
          <span style={contextMenuStyle} className='context-menu-style'>
            <button className='first-btn' onClick={this.addSite}>Update Location</button>
            {/*<button onClick={this.updateSite}>Update Site</button>*/}
          </span>
          <header>
            <span className="dashboard-info">
              <div className="container"><button onClick={this.backBtnClick}>Back</button>&nbsp;Enter address below to find location on map. Then right click on map to Add or Update location.</div>
            </span>
            <PlacesAutocomplete
              inputProps={inputProps}
              onSelect={this.placesHandleSelect}
              onEnterKeyDown={this.placesHandleSelect}
              autocompleteItem={AutocompleteItem}
            />
          </header>


          < GoogleMapReact
            defaultCenter={this.state.center}
            center={this.state.center}
            defaultZoom={18}
            onClick={this.mapClick}
            onGoogleApiLoaded={this.mapLoaded}
            yesIWantToUseGoogleMapApiInternals
            ref="chooseLocationMap"
          >
            <CenterMarkerComponent lat={this.state.center.lat}
                                   lng={this.state.center.lng}  />

            {markersComponents}


          </GoogleMapReact >
        </div>
      );
    } else {
      return null;
    }

  }

}



class MarkerComponent extends Component {
  constructor(props) {
    super(props)
  }
  render() {

    return (
      <span className="marker-translate" ><img src="/img/marker.png" alt="" /></span>
    );
  }
}


class CenterMarkerComponent extends Component {
  constructor(props) {
    super(props)
  }
  render() {

    return (
      <span className="marker-translate" ><img src="/img/center_marker.png"  /></span>
    );
  }
}

let select = (state, props) => ({
  userLocation: state.user.position,
  userProfile: state.user.profile,
});
export default connect(select)(ChooseLocationMap);



// WEBPACK FOOTER //
// ./src/js/components/settings/ChooseLocationMap.js